import React from 'react';
import { ArrowRight, Shield, Clock, Users } from 'lucide-react';

const Hero = () => {
  return (
    <section 
      id="hero" 
      className="relative min-h-[90vh] flex items-center pt-20 pb-12 px-6 bg-hero"
      data-testid="hero-section"
    >
      {/* Subtle industrial background pattern */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-[#1e3a5f]/[0.03] rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
        <div 
          className="absolute inset-0 opacity-[0.02]"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M50 50 L50 0 M50 50 L100 50 M50 50 L50 100 M50 50 L0 50' stroke='%231e3a5f' stroke-width='0.5' fill='none'/%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px',
          }}
        ></div>
      </div>

      <div className="max-w-5xl mx-auto w-full relative z-10">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#1e3a5f]/8 border border-[#1e3a5f]/15 rounded-full mb-6">
          <div className="w-2 h-2 bg-[#1e3a5f] rounded-full"></div>
          <span className="text-sm font-semibold text-[#1e3a5f] tracking-wide">UK Mechanical Services Acquisition</span>
        </div>

        {/* Main Headline */}
        <h1 className="text-[2.5rem] md:text-[3.25rem] lg:text-[3.75rem] font-bold text-[#1a1a1a] leading-[1.1] tracking-tight mb-5 max-w-4xl">
          Long-Term Acquisition of UK Mechanical Services Businesses
        </h1>

        {/* Subtext */}
        <p className="text-lg md:text-xl text-[#3d3d3d] max-w-3xl mb-8 leading-relaxed">
          We acquire and operate established UK HVAC and mechanical services businesses for the long term — preserving your team, protecting your customers, and safeguarding your legacy.
        </p>

        {/* Proof Points - Balanced 2 lines each */}
        <div className="grid sm:grid-cols-3 gap-4 mb-8">
          <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-[#c5c1b8] shadow-sm">
            <div className="w-10 h-10 rounded-lg bg-[#1e3a5f] flex items-center justify-center flex-shrink-0">
              <Users className="w-5 h-5 text-white" />
            </div>
            <div>
              <span className="text-sm font-semibold text-[#1a1a1a] block">Personal Commitment</span>
              <span className="text-xs text-[#5a5a5a]">Owner-operated, not private equity.</span>
            </div>
          </div>
          <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-[#c5c1b8] shadow-sm">
            <div className="w-10 h-10 rounded-lg bg-[#1e3a5f] flex items-center justify-center flex-shrink-0">
              <Shield className="w-5 h-5 text-white" />
            </div>
            <div>
              <span className="text-sm font-semibold text-[#1a1a1a] block">Strict Confidentiality</span>
              <span className="text-xs text-[#5a5a5a]">NDA signed before any sensitive data.</span>
            </div>
          </div>
          <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-[#c5c1b8] shadow-sm">
            <div className="w-10 h-10 rounded-lg bg-[#1e3a5f] flex items-center justify-center flex-shrink-0">
              <Clock className="w-5 h-5 text-white" />
            </div>
            <div>
              <span className="text-sm font-semibold text-[#1a1a1a] block">Single Acquisition Focus</span>
              <span className="text-xs text-[#5a5a5a]">Fast, decisive process.</span>
            </div>
          </div>
        </div>

        {/* CTA */}
        <a
          href="#contact"
          className="btn-primary inline-flex"
          data-testid="hero-cta-primary"
        >
          Arrange a Confidential Discussion
          <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </section>
  );
};

export default Hero;
